import { createSlice } from '@reduxjs/toolkit';
import { MapsState } from './maps.types';
import { MAPS_SLICE_NAME } from './maps.constants';
import { getProjectMapsReducer, updateMapReducer } from './maps.reducers';

const initialState: MapsState = {
  data: [],
  loading: 'idle',
  updateLoading: {},
  error: null,
};

const mapsSlice = createSlice({
  name: MAPS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    getProjectMapsReducer(builder);
    updateMapReducer(builder);
  },
});

export default mapsSlice.reducer;
